<template>
  <div>

  <div class="header">
      <div class="assheaderLeft">
        <img  src="../../assets/img/home/icon_网站logo.png" alt="" @click="gohome">
      </div>
    <div class="assheaderCent">
      <el-menu :default-active="activeIndex" active-text-color="#AC4B38"  class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">古籍库</template>
          <el-menu-item index="2-1">基本古籍库</el-menu-item>
          <el-menu-item index="2-2">域外古籍库</el-menu-item>
          <el-menu-item index="2-3">孤本库</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">知识库</template>
          <el-menu-item index="3-1">医案</el-menu-item>
          <el-menu-item index="3-2">方剂</el-menu-item>
          <el-menu-item index="3-3">名医</el-menu-item>
          <el-menu-item index="3-4">本草</el-menu-item>
          <el-menu-item index="3-5">经穴</el-menu-item>
        </el-submenu>
        <el-menu-item index="4">课程库</el-menu-item>
        <el-menu-item index="5">中医圈</el-menu-item>
        <el-menu-item index="6">中医智库APP</el-menu-item>
      </el-menu>
    </div>
    <div class="assheaderRight">
      <span  @keyup.enter="showSearch()"  @click="showSearch"><a href="#"><img src="../../assets/img/home/icon_搜索_选中.png" alt="">搜索</a></span >

      <div v-if="institution_name" class="jigou">
        {{institution_name}}
      </div>
      <dl v-show="!loginType">
        <dt @click="personal"><img style="border-radius: 50%" :src="avatar"  :onerror="default_cattle" alt=""></dt>
      </dl>
      <el-button v-show="loginType" class="headerBtn"  @click="login" style="">登录/注册</el-button>
    </div>
  </div>
  <SearchAssembly  v-if="show"/>
  </div>
</template>

<script>
import SearchAssembly from '../searchAssembly/searchAssembly';
import avatar from '@/assets/default/avatar.png'
export default {
    components:{
      SearchAssembly
    },
  data() {
    return {
      default_cattle: 'this.src="' + require('../../assets/default/avatar.png') + '"',
      activeIndex:this.$route.query.key?this.$route.query.key:'1',
      show:false,
      searchVal: '',
      loginType:false,
      avatar:avatar,
      institution_name:'',
    };
  },
  beforeCreate() {
    this.$commFun.loginTypes().then(res => {
      if(res.status_code == "201"){
        this.loginType = true
      }else {
        this.loginType = false
        this.avatar = res.data.avatar
      }
    })
  },
  mounted() {
    this.institution_name = localStorage.getItem('institution_name')
    this.show = this.$route.query.show? this.$route.query.show:false;
    this.searchVal = this.$route.query.searchInput? this.$route.query.searchInput:'';

  },
  methods: {
      //跳转个人页
    personal(){
      this.$router.push({
        name:"personalInfo",
      })
    },
    gohome(){
      this.$router.push({
        name:"home",
      })
    },
    // 头部tab选中跳转界面
    handleSelect(key, keyPath) {
      this.activeIndex = key
      this.$store.commit('setkey',key)
      if(keyPath[0] == 1){
        this.$router.push({
          name:"home",
          query:{
            "key":key,
          }
        })
      }
      else if(keyPath[0] == 2){
        this.$router.push({
          name:"ancientBooks",
          query:{
            "key":key,
          }
        })
      }else if(keyPath[0]== 3){
        this.$router.push({
          name:"knowledgeBooks",
          query:{
            "key":key,
          }
        })
      }else if (keyPath[0] ==4) {
        window.open(`https://app0hdojbcy5778.h5.xiaoeknow.com/p/decorate/homepage`);
      }else if(keyPath[0] == 5){
        //console.log("进入中医圈");
        this.$router.push({
          name:"chineseMedicine",
          query:{
            "key":key,
          }
        })
      }  else if (keyPath[0] == 6) {
        this.$store.commit('setkey', key)
        this.$router.push({
          name: "APPDownload",
          query: {
            "key": key
          }

        })
      }
    },
    // 是否展示搜索区域
    showSearch(){
      this.show=!this.show
    },
    // 登录
    login(){
      this.$router.push({
        name:"login",
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  width: 100%;
  display: flex;
  background:#fff;
  align-items: center;
  box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.12);
  .assheaderLeft{
    padding-left:40px;
    img{
      width: 200px;height: 70px
    }
  }
  .assheaderCent{
   flex: 1;
    display: flex;
    justify-content: center;
    /deep/ .el-menu.el-menu--horizontal {
      border-bottom: none !important;
    }
    /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
      color: #333 !important;
    } /deep/ .el-menu--horizontal>.el-menu-item{
      color: #333 !important;
    }
    /depp/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
      color: #333 !important;
    }
  }
  .assheaderRight{
   width:450px;
    display: flex;
    justify-content: center;
    align-items: center;
    .jigou{
      width: 184px;
      height: 40px;
      background: rgba(255,255,255,0.5);
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #AC4B38;
      backdrop-filter: blur(20px);
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #AC4B38;
      float: left;
    }
    span{
      a{
        text-decoration: none;
        float: left;
        display: flex;
        width: 100px;
        justify-content: center;
        align-items: center;
        color: #AC4B38;
        font-size: 16px;
      }

    }
    .headerBtn{
      float: right;
      margin-right: 40px;
      width: 120px;
      height: 36px;
      font-size:16px;
      background: linear-gradient(315deg, #D68269 0%, #AC4B38 100%);
      color:#F1F1F1;
      border: none
    }

    dl{
      float: right;
      margin-right: 20px;
      width: 100px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      dt{
        img{
          width: 50px;
          height: 50px;
          object-fit: cover;
        }
      }
    }
  }

}
</style>
